/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Free_TitleInputs */

const en_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const ar_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاناً`)
};

const de_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const es_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const it_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuito`)
};

const ja_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const ko_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

const pt_br_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ru_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const th_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟรี`)
};

const tr_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz`)
};

const zh_cn_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版`)
};

const zh_tw_subscription_service_level_compare_free_title = /** @type {(inputs: Subscription_Service_Level_Compare_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費版`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Subscription_Service_Level_Compare_Free_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_free_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Free_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Free_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_free_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_free_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_free_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_free_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_free_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_free_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_free_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_free_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_free_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_free_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_free_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_free_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_free_title(inputs)
	return zh_tw_subscription_service_level_compare_free_title(inputs)
});